import { render, staticRenderFns } from "./ListagemItensAtaView.vue?vue&type=template&id=483f2881&scoped=true"
import script from "./ListagemItensAtaView.vue?vue&type=script&lang=js"
export * from "./ListagemItensAtaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483f2881",
  null
  
)

export default component.exports